module.exports = __webpack_public_path__ + "static/img/CHANG_CHING-YEH.png";